import React, { useState, useEffect } from 'react';

const DateTimeInput = ({ apiDate, onChange }) => {
  // Convert the API date to the correct format for input[type="datetime-local"]
  const convertToLocalDateTime = (isoDate) => {
    const date = new Date(isoDate);
    const pad = (num) => num.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // getMonth() returns month from 0 to 11
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [dateTime, setDateTime] = useState('');

  useEffect(() => {
    if (apiDate) {
      setDateTime(convertToLocalDateTime(apiDate));
    }
  }, [apiDate]);

  const convertToApiDate = (localDateTime) => {
    const date = new Date(localDateTime);
    return date.toISOString();
  };

  const handleChange = (event) => {
    const newDateTime = event.target.value;
    setDateTime(newDateTime);
    if (onChange) {
      const apiDate = convertToApiDate(newDateTime);
      onChange(apiDate);
    }
  };

  return (
    <input
      type="datetime-local"
      name="issuedDate"
      value={dateTime}
      onChange={handleChange}
    />
  );
};

export default DateTimeInput;
